export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer__mark" aria-label="C’mon meet me on the dancefloor">
        <span>C’mon meet me</span>
        <span>on the dancefloor</span>
      </div>
      <nav className="site-footer__links" aria-label="Information">
        <a href="/terms#terms">Terms and Conditions</a>
        <a href="/terms#privacy">Privacy Policy</a>
        <a href="/about">About the Project</a>
      </nav>
      <p>Lookport Studio × Outernet London · 2026</p>
    </footer>
  );
}
